import styled from "styled-components";
import { Type } from "@ebscois/react-component-library";

export const StyledNoAccountParagraph = styled(Type)`
  margin-top: ${({ theme }) => theme.space.sm};
`;
